module.exports = __webpack_public_path__ + "static/media/calefont3.b4fbab2b.png";